import Controller from "csi/action/Controller";
import CsiFormData from "csi/action/FormData";
import html from "csi/html";
import session from "csi/session";
import { setLocationHash } from "csi/utility/routerUtility";
import declare from "dojo/_base/declare";
import topic from "dojo/topic";

const AddToEngineeringChangeController = declare(Controller, {

	/**
	 * @override
	 * Only one selection is allowed in the view & New EngineeringChange creation is also allowed.
	 */
	onFormData(fd: CsiFormData): void {
		fd.m_bSelectOne = true;
		fd.m_bEditable = true;
	},

	/**
	 * @override
	 * Remove the actions & edit capabilities in the view
	 */
	onCreatePopupParams(params): void {
		params.onCreateMainQueryLevel = (ql): void => {
			ql.bReadOnly = true;
			ql.actions = null;
		};
	},

	/**
	 * @override
	 * Show wait for slower connections & save from form directly takes to the created node.
	 */
	onStart(): void {
		this._registerEventHandle(topic.subscribe("/csi/action/start", (ac) => {
			if (ac.m_action.m_id === "NewEngineeringChange") {
				ac.onStartPublish = (): void => {
					html.showWait(true);
				};
				ac.onEnd = (): void => {
					if (ac.endStatus) {
						setTimeout(() => {
							this.resumeProcess();
							this.process();
						}, 1);
					}
				};
			}
		}));
	},

	/**
	 * @override
	 * Save from the view directly takes to the created node and to AffectedItems Tab.
	 */
	postProcessSuccess() {
		html.showWait(false);

		const navNodeURL = this.m_formData.getSelectedNode().$URL;
		if (navNodeURL) {
			const params = {};
			params[session.LOCATION_URL] = navNodeURL;
			params[session.LOCATION_TAB] = "AffectedItemsView";
			setLocationHash(session.getLocation(null, params));
		} else {
			this.inherited(arguments);
		}
	},
});

export = AddToEngineeringChangeController;